import { TLang } from 'src/constants/langs'
import { LocalizedText } from 'src/types/common/localized'

import { TextHeaderEn } from './en/TextHeaderEn'
import { TextHeaderDe } from './de/TextHeaderDe'
import { TextHeaderRo } from './ro/TextHeaderRo'
import { TextHeaderEs } from './es/TextHeaderEs'
import { TextHeaderFr } from './fr/TextHeaderFr'
import { TextHeaderIt } from './it/TextHeaderIt'
import { TextHeaderPt } from './pt/TextHeaderPt'
import { TextHeaderEl } from './el/TextHeaderEl'
import { TextHeaderSl } from './sl/TextHeaderSl'

export const texts: Record<TLang, LocalizedText> = {
    en: { header: <TextHeaderEn /> },
    de: { header: <TextHeaderDe /> },
    ro: { header: <TextHeaderRo /> },
    es: { header: <TextHeaderEs /> },
    fr: { header: <TextHeaderFr /> },
    it: { header: <TextHeaderIt /> },
    pt: { header: <TextHeaderPt /> },
    el: { header: <TextHeaderEl /> },
    sl: { header: <TextHeaderSl /> },
}
